import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Typography
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";

const rows = [
  {
    feature: "Type",
    vermi: "100% Organic",
    ferti: "Synthetic"
  },
  {
    feature: "Nutrient Release",
    vermi: "Slow and steady, long-lasting",
    ferti: "Immediate but short-term"
  },
  {
    feature: "Soil Health Impact",
    vermi: "Improves structure & fertility",
    ferti: "May degrade over time"
  },
  {
    feature: "Environmental Impact",
    vermi: "Eco-friendly & sustainable",
    ferti: "Risk of pollution"
  },
  {
    feature: "Microbial Activity",
    vermi: "Boosts beneficial microbes",
    ferti: "Often reduces microbial life"
  },
  {
    feature: "Best Use",
    vermi: "Long-term soil health",
    ferti: "Quick fixes only"
  }
];

export default function CompareTable() {
  return (
    <Box px={{ xs: 2, md: 8 }} py={5}>
      <Typography variant="h2" textAlign="center" mb={1}>
        Vermicompost vs Fertilizer
      </Typography>

      <Typography
        color="text.secondary"
        textAlign="center"
        mb={6}
      >
        Understand why organic vermicompost is the superior choice
      </Typography>

      <Paper
        elevation={0}
        sx={{
          borderRadius: 4,
          overflow: "hidden"
        }}
      >
        <Table>
          {/* HEADER */}
          <TableHead>
            <TableRow>
              <TableCell sx={headerStyleLeft}>
                Feature
              </TableCell>
              <TableCell sx={headerStyleMiddle}>
                Vermicompost
              </TableCell>
              <TableCell sx={headerStyleRight}>
                Fertilizer
              </TableCell>
            </TableRow>
          </TableHead>

          {/* BODY */}
          <TableBody>
            {rows.map((row, index) => (
              <TableRow
                key={row.feature}
                sx={{
                  bgcolor:
                    index % 2 === 0 ? "#FFFFFF" : "#F6F8F3"
                }}
              >
                <TableCell sx={featureCell}>
                  {row.feature}
                </TableCell>

                <TableCell sx={vermiCell}>
                  <CheckIcon sx={{ color: "#2E7D32", mr: 1 }} />
                  {row.vermi}
                </TableCell>

                <TableCell sx={fertiCell}>
                  <CloseIcon sx={{ color: "#D32F2F", mr: 1 }} />
                  {row.ferti}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
}

/* ================= STYLES ================= */

const headerStyleLeft = {
  bgcolor: "#2E4F23",
  color: "#fff",
  fontWeight: 700,
  fontSize: 16,
};

const headerStyleMiddle = {
  bgcolor: "#556B2F",
  color: "#fff",
  fontWeight: 700,
  fontSize: 16
};

const headerStyleRight = {
  bgcolor: "#2E4F23",
  color: "#fff",
  fontWeight: 700,
  fontSize: 16
};

const featureCell = {
  fontWeight: 600,
  width: "30%"
};

const vermiCell = {
  color: "#2E7D32",
  fontWeight: 500,
  width: "35%"
};

const fertiCell = {
  color: "#6D4C41",
  fontWeight: 500,
  width: "35%"
};
